import React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import MuiDialog, { DialogProps as MuiDialogProps } from '@material-ui/core/Dialog';
import classnames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface DialogProps extends Omit<MuiDialogProps, 'classes'>, WithStyles<typeof styles> {
  preventSubmit?: boolean;
}

const Dialog: React.FC<DialogProps> = ({ classes, className, preventSubmit, ...rest }) => (
  <MuiDialog
    onKeyDown={(e) => {
      // Prevent dialogs from submitting forms on higher components
      if (preventSubmit && e.key === 'Enter') {
        e.preventDefault();
      }
    }}
    className={classnames(classes.root, className)}
    {...rest}
  />
);

export default withStyles(styles, { name: 'LumaDialog' })(Dialog);
